import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "./Heading.module.css";

export default function Heading({ children, className = "", size = "m" }) {
  const classes = classNames({
    [className]: true,
    [styles.Heading]: true,
    [styles.medium]: size === "m",
    [styles.large]: size === "l",
  });
  return <h2 className={classes}>{children}</h2>;
}

Heading.propTypes = {
  className: PropTypes.string,
  size: PropTypes.oneOf(["m", "l"]),
};
